import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import React from "react";
import { deleteFaqApi } from "services/faq";
import { toastMessage } from "utils/toastMessage";

const DeleteFaq = ({
  deleteModal,
  selectedFaqDetail,
  setFaqList,
  closeModel,
}) => {
  const [faqButtonLoader, setFaqButtonLoader] = useButtonLoader("Yes");

  const deleteFaqHandler = async () => {
    try {
      setFaqButtonLoader(true);
      const { data: responseData, status } = await deleteFaqApi(
        selectedFaqDetail._id
      );
      if (status === 200) {
        // Remove the deleted category from the list
        setFaqList((prevList) =>
          prevList.filter((faq) => faq._id !== selectedFaqDetail._id)
        );
        closeModel();
        toastMessage(responseData.message, "success", "deleteFaq");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setFaqButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={deleteModal}
        handleClose={closeModel}
        content="Are you sure you want to Delete this faq?"
        title="Delete Faq"
        buttonLoader={faqButtonLoader}
        action={deleteFaqHandler}
      />
    </>
  );
};

export default DeleteFaq;
